import { render, staticRenderFns } from "./SvgFrontFrameNotificationCard.vue?vue&type=template&id=7051a0a2&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports